import fetch from "auth/GenericFetchInterceptorV5";
import { documentId } from "firebase/firestore/lite";

const SuppliersService = {};

SuppliersService.addSupplier = function (body) {
    return fetch({
        url: `/api/suppliers`,
        method: "POST",
        data:body
    });
};
SuppliersService.getSources = function (documentId) {
    console.log("documentiId in getSources",documentId)
    return fetch({
        url: `/api/catalog-suppliers?populate=supplier&filters[company][documentId]=${documentId}`,
        method: "GET",
    });
};

SuppliersService.getSourcesAfter = function (companyDocId, updatedAtISO) {
    return fetch({
        url: `/api/catalog-suppliers?populate=supplier&filters[company][documentId]=${companyDocId}&filters[supplier][updatedAt][$gt]=${updatedAtISO}`
    })
}

// New method to get just the count of suppliers for a company
SuppliersService.getSourcesCount = function (companyDocId) {
    return fetch({
        url: `/api/catalog-suppliers?filters[company][documentId]=${companyDocId}&pagination[pageSize]=1&pagination[page]=1`,
        method: "GET",
    });
};

SuppliersService.getCode = function () {
    return fetch({
        url: `/api/suppliers/next-cod`,
        method: "GET",
    });
};

SuppliersService.updateSupplier = function (documentId, body) {

    return fetch({
        url: `/api/suppliers/${documentId}`,
        method: "PUT",
        data: body
    });
};

SuppliersService.deleteSource = function (documentId) {
    console.log("Elimino supplier con documentId:", documentId);
    return fetch({
        url: `/api/suppliers/${documentId}`,
        method: "DELETE"
    });
};

export default SuppliersService;
